import terms from 'pages/Terms/dict'

const { TERMS_OF_USE, PRIVACY_POLICY, COOKIES_POLICY, DELETION_POLICY } = terms

const socialNetworks = [
  {
    icon: 'facebook',
    link: 'https://www.facebook.com/resale.com.br/',
  },
  {
    icon: 'instagram',
    link: 'https://www.instagram.com/resalebr/',
  },
  {
    icon: 'linkedin',
    link: 'https://www.linkedin.com/company/resalebr',
  },
  {
    icon: 'youtube',
    link:
      'https://www.youtube.com/channel/UCOQPpSCHs1NPfeJYsOi1AnQ/featured?view_as=subscriber',
  },
]

const profilers = [
  {
    text: 'Quero investir nesse tipo de imóvel mas ainda não tenho experiência',
    profile: 'starter',
  },
  {
    text:
      'Sou um(a) investidor(a) experiente e quero ter acesso a boas oportunidades',
    profile: 'experienced',
  },
  {
    text:
      'Sou arrojado(a) e quero ter acesso a boas oportunidades independete do risco',
    profile: 'risky',
  },
  {
    text: 'Quero um imóvel para morar',
    profile: 'home',
  },
]

const links = [
  {
    title: 'Institucional',
    links: [
      {
        name: 'Perguntas frequentes',
        link: '/perguntas-frequentes',
      },
      {
        name: 'Fale Conosco',
        link: '/fale-conosco',
      },
      {
        name: 'Parcerias',
        link: '/parcerias',
      },
    ],
  },
  {
    title: 'Imóveis',
    links: [
      {
        name: 'Para morar',
        link: '/busca?situacao=desocupado',
      },
      {
        name: 'Para investir',
        link: '/busca',
      },
      {
        name: 'Leilões',
        link: '/busca?tipo-venda=Leilao',
      },
      {
        name: 'Venda direta',
        link: '/busca?tipo-venda=vendaDireta',
      },
      {
        name: 'Fazendas',
        link: '/busca?tipo-imovel=fazenda',
      },
    ],
  },
  {
    title: 'Pagimovel®',
    links: [
      {
        name: 'Minhas Propostas',
        link: 'https://clientes.pagimovel.com.br/welcome',
      },
    ],
  },
  {
    title: 'Termos e Privacidade',
    links: [
      {
        name: 'Termos e Condições de Uso',
        link: '/termos',
        term: TERMS_OF_USE,
      },
      {
        name: 'Política de Privacidade',
        link: '/termos',
        term: PRIVACY_POLICY,
      },

      {
        name: 'Política de Cookies',
        link: '/termos',
        term: COOKIES_POLICY,
      },
      {
        name: 'Política de Exclusão de Dados',
        link: '/termos',
        term: DELETION_POLICY,
      },
    ],
  },
]
export { socialNetworks, profilers, links }
